import './index.css'
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../../assets/img/color-sharp.png"
import resume from "../../assets/Keerthivasan-K-Resume.pdf"
export const About = () => {


    return (
        <section className="about" id="about">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="about-bx wow zoomIn">
                            <h2>About</h2>
                            <p>
                                Hi there! My name is Keerthivasan K and I am a fresher game developer with a strong passion for creating immersive
                                and engaging experiences through video games. I recently graduated with a degree in MCA (Master Of Computer Application) and have been
                                honing my skills in game development through various projects and coursework. I have knowledge in software's like Unity, Unreal Engine, Blender
                                and am always looking to learn and expand my skillset. I am excited to start my career in the gaming industry and am eager to bring my creativity and dedication to a dynamic team.</p>
                            <a href={resume} download="Resume">
                                <button  ><span>Download Resume</span></button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <img className="background-image-left" src={colorSharp} alt="Image" />
        </section>
    )
}
